/**
 * The three price-line keys (entry / sl / tp) of a position or pending order,
 * used to highlight a whole group together. Extracted from Chart.tsx.
 */
export function tradingGroupKeys(scope: "pos" | "order", ticket: number): string[] {
  return scope === "pos"
    ? [`pos-entry:${ticket}`, `pos-sl:${ticket}`, `pos-tp:${ticket}`]
    : [`order-entry:${ticket}`, `order-sl:${ticket}`, `order-tp:${ticket}`];
}
